import styled from "styled-components"

export const StyledHowItAllStartedWrapper = styled.div`
  max-width: 922px;
  padding-right: 40px;
  @media only screen and (max-width: 767px) {
    padding-right: 28px;
  }
`
